import React, { useState, useEffect } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { userService } from "../../_services";

function Affiliate_id_total({ Referrals }) {
    const [referralCount, setReferralCount] = useState('N/A');
    const [refBonus, setRefBonus] = useState('');

    useEffect(() => {
        try {
            const Usermeta_Data = window.atob(localStorage.getItem('ajs_user_id'));
            const userId = Usermeta_Data.split(':')[0];

            userService.GetUserReferalBonus(userId).then(apidata => {
                let total = 0;
                if (apidata.length > 0) {
                    total = apidata[0].subDistComm.toFixed(2);
                }
                setRefBonus(total);
            }).catch(err => console.error('Error fetching referral bonus:', err));

            const uniqueNames = [...new Set(Referrals.map(r => r.userName))];
            setReferralCount(uniqueNames.length);
        } catch (error) {
            console.error('Error in Affiliate_id_total mount:', error);
        }
    }, [Referrals]);

    return (
        <Card>
            <CardContent className="p-0">
                <div className="grid grid-cols-2 divide-x divide-border">
                    <div className="p-6 text-center">
                        <p className="text-lg font-medium text-muted-foreground mb-2">Total Referrals</p>
                        <span className="text-3xl font-bold text-foreground">{referralCount}</span>
                    </div>
                    <div className="p-6 text-center">
                        <p className="text-lg font-medium text-muted-foreground mb-2">Referral Commission</p>
                        <span className="text-3xl font-bold text-foreground">${refBonus}</span>
                    </div>
                </div>
            </CardContent>
        </Card>
    );
}

export default Affiliate_id_total;
